import {Component, Injector} from '@angular/core';
import {BasePageComponent} from '../../../base/components/base-page.component';

@Component({
  selector: 'app-setting-modal',
  templateUrl: './setting-modal.component.html',
  styleUrls: ['./setting-modal.component.scss']
})
export class SettingModalComponent extends BasePageComponent {

  activeModal: string;

  constructor(injector: Injector) {
    super(injector);
    // modal service
    this.modalService.modal.subscribe((id) => {
      this.activeModal = id;
    });
  }

  pageName(): string {
    return 'SettingModalComponent';
  }

  ngOnInitForChildren(): void {
  }

  ngOnDestroyForChildren(): void {
  }

}
